import { render, staticRenderFns } from "./CreateReorderViewsModal.vue?vue&type=template&id=8f7937ae"
import script from "./CreateReorderViewsModal.vue?vue&type=script&lang=js"
export * from "./CreateReorderViewsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports